import * as React from "react";

function SvgGrayStatusIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} {...props}>
      <g
        data-name="Grupo 1519"
        transform="translate(-787.047 -363)"
        fill="#6c7485"
      >
        <circle
          data-name="Elipse 20"
          cx={7}
          cy={7}
          r={7}
          transform="translate(787.047 363)"
          opacity={0.15}
        />
        <circle
          data-name="Elipse 12"
          cx={3}
          cy={3}
          r={3}
          transform="translate(791.047 367)"
        />
      </g>
    </svg>
  );
}

export default SvgGrayStatusIcon;

